<script>
import blob from '../components/blob.vue';
import liquidBackground from '../components/liquid-background.vue';
import magnetic from '../components/Magnetic.vue';

export default {
    components: {
        blob,
        liquidBackground,
        magnetic
    },

    data() {
        return {
            isAnimating: false,
            isOpen: false
        };
    },

    mounted() {
        if (this.$root.navOpen === true) {
            this.open();
        }
    },

    methods: {
        open() {
            document.querySelector('html, body').classList.add('overflow-hidden');
            this.$refs.modal.classList.remove('opacity-0');
            document.addEventListener('keyup', this.escapeClose);

            this.isOpen = true;
            this.$refs.liquid.toggle();
        },

        liquidResponse() {
            if (this.isOpen) {
                this.animateIn();
            } else {
                this.close();
            }
        },

        animateIn() {
            /* :: Set the Stage
            {+} ---------------------------------- */
            this.$refs.logo.classList.remove('invisible');
            this.$refs.close.classList.remove('invisible');
            this.$refs.socials.classList.remove('invisible');
            this.$refs.buyTickets.classList.remove('invisible');
            this.$refs.buyTicketsMobile.classList.remove('invisible');

            const navIn = gsap.timeline();

            gsap.utils.toArray('[data-nav-main-item]').forEach((menuItem, i) => {
                navIn.fromTo(
                    menuItem,
                    { y: '40%', opacity: 0 },
                    { y: '0', opacity: 1, duration: 0.8, ease: 'quint.inOut' },
                    i === 0 ? '' : '<0.1'
                );
            });

            gsap.utils.toArray('[data-nav-secondary-item]').forEach((menuItem, i) => {
                navIn.fromTo(
                    menuItem,
                    { y: 60, opacity: 0 },
                    { y: 0, opacity: 1, duration: 0.5, ease: 'circ.inOut' },
                    i === 0 ? '<-0.1' : '<0.1'
                );
            });

            navIn
                .fromTo(
                    this.$refs.blob,
                    { y: '50%', scale: 0.5, opacity: 0 },
                    { y: '0', scale: 1, opacity: 1, duration: 1.2, ease: 'back.out' },
                    '<-0.4'
                )
                .to(
                    this.$refs.divider,
                    {
                        opacity: 0.5,
                        duration: 0.3
                    },
                    '<0'
                )
                .to(
                    this.$refs.socials,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0.6'
                )
                .to(
                    this.$refs.logo,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<-0.6'
                )
                .to(
                    this.$refs.entryWindow,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0.1'
                )
                .to(
                    this.$refs.buyTickets,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0.1'
                )
                .to(
                    this.$refs.entryWindowMobile,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0'
                )
                .to(
                    this.$refs.buyTicketsMobile,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0.1'
                )
                .to(
                    this.$refs.close,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0.2'
                );
        },

        animateOut() {
            this.$root.$emit('cursorClick');

            if (!this.isAnimating) {
                this.isAnimating = true;

                const navOut = gsap.timeline({
                    onComplete: () => {
                        /* :: Reset the Stage
                        {+} ---------------------------------- */
                        this.$refs.close.classList.add('invisible');

                        this.isOpen = false;
                        this.$refs.liquid.toggle();
                        this.isAnimating = false;
                    }
                });

                navOut
                    .to(this.$refs.close, {
                        opacity: 0,
                        duration: 0.4
                    })
                    .to(
                        this.$refs.entryWindow,
                        {
                            opacity: 0,
                            duration: 0.4
                        },
                        '<0.1'
                    )
                    .to(
                        this.$refs.buyTickets,
                        {
                            opacity: 0,
                            duration: 0.4
                        },
                        '<0.1'
                    )
                    .to(
                        this.$refs.entryWindowMobile,
                        {
                            opacity: 0,
                            duration: 0.4
                        },
                        '<0'
                    )
                    .to(
                        this.$refs.buyTicketsMobile,
                        {
                            opacity: 0,
                            duration: 0.4
                        },
                        '<0.1'
                    )
                    .to(
                        this.$refs.logo,
                        {
                            opacity: 0,
                            duration: 0.4
                        },
                        '<0.1'
                    )
                    .to(
                        this.$refs.socials,
                        {
                            opacity: 0,
                            duration: 0.4
                        },
                        '<-0.1'
                    )
                    .to(
                        this.$refs.divider,
                        {
                            opacity: 0,
                            duration: 0.3
                        },
                        '<0'
                    )
                    .to(this.$refs.blob, { y: '-50%', scale: 0.6, opacity: 0, duration: 0.7, ease: 'quint.in' }, '<0');

                gsap.utils.toArray('[data-nav-main-item]').forEach((menuItem, i) => {
                    navOut.to(
                        menuItem,
                        { y: '-40%', opacity: 0, duration: 0.8, ease: 'quint.in' },
                        i === 0 ? '' : '<0.1'
                    );
                });

                gsap.utils.toArray('[data-nav-secondary-item]').forEach((menuItem, i) => {
                    navOut.to(
                        menuItem,
                        { y: -60, opacity: 0, duration: 0.5, ease: 'circ.in' },
                        i === 0 ? '<-0.1' : '<0.1'
                    );
                });
            }
        },

        close() {
            document.removeEventListener('keyup', this.escapeClose);
            document.querySelector('html, body').classList.remove('overflow-hidden');
            this.$root.navOpen = false;
        },

        escapeClose(event) {
            if (event.keyCode === 27) {
                this.animateOut();
            }
        }
    }
};
</script>
